import axios from "axios";

const BASE_URL = "https://cloud.seatable.io/api-gateway/api/v2/dtables";
const BASE_UUID = "f6058011-cd70-403e-bf7c-340a2fd6f10b";
const BASE_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3NjQ0MDA2MDcsImR0YWJsZV91dWlkIjoiZjYwNTgwMTEtY2Q3MC00MDNlLWJmN2MtMzQwYTJmZDZmMTBiIiwicGVybWlzc2lvbiI6InJ3Iiwib3JnX2lkIjo2ODc0MCwib3duZXJfaWQiOiIyODc3ODUxMzhjNzI0MWZjOWEwMzA5NTZmOGQ1NWQwZkBhdXRoLmxvY2FsIiwiYXBwX25hbWUiOiJiZWxhbnRhcmEiLCJ1c2VybmFtZSI6IiIsImlkX2luX29yZyI6IiIsInVzZXJfZGVwYXJ0bWVudF9pZHNfbWFwIjp7ImN1cnJlbnRfdXNlcl9kZXBhcnRtZW50X2lkcyI6W10sImN1cnJlbnRfdXNlcl9kZXBhcnRtZW50X2FuZF9zdWJfaWRzIjpbXX19.AD9co4ECXKzNARoTgc8mK2bitEkx-DQ6LDDufGPZJTs";

export async function seaTableSQL(sql) {
  try {
    const response = await axios.post(
      `${BASE_URL}/${BASE_UUID}/sql/`,
      { sql, convert_keys: true },
      {
        headers: {
          Authorization: `Token ${BASE_TOKEN}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error executing SQL:", error.response?.data || error);
  }
}

export async function getTable(table) {
  try {
    const response = await axios.get(
      `${BASE_URL}/${BASE_UUID}/rows/?table_name=${table}`,
      {
        headers: {
          Authorization: `Token ${BASE_TOKEN}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching table:", error.response?.data || error);
  }
}
